import React from 'react';
import { Row, Col, Typography } from 'antd';

const {Text} = Typography;
export default function Marquee() {
  return (
    <Row>
      <Col span={24} className='marquee-container'>
     
          <Text className="marquee-text animate-marquee">
            Hello....Welcome to Burmese Slot....Enjoy Your Day
          </Text>
        
      </Col>
    </Row>
  );
}